module.exports = __webpack_public_path__ + "img/talking_learning_machine_ad.bd6e4eb1.jpg";